import { render, staticRenderFns } from "./IconFileVideo.vue?vue&type=template&id=2b64d090"
import script from "./IconFileVideo.vue?vue&type=script&lang=js"
export * from "./IconFileVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports